import BankAccountCreateModal from "./BankAccountCreateModal"

export default BankAccountCreateModal
